import { render } from "./Initiated.vue?vue&type=template&id=6815880c"
import script from "./Initiated.vue?vue&type=script&lang=js"
export * from "./Initiated.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Initiated.vue?vue&type=style&index=1&id=6815880c&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__